import { P } from 'components'
import { useDebounce } from 'helpers'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Spinner } from 'reactstrap'
import { useLazyFindProjectQuery } from '../projectApiSlice'
import { setIsModalOpenAddProject } from '../projectSlice'
import './styles.scss'

const InputProject = ({
  title = 'Project',
  placeholderDesc = 'Cari nama project dari daftar project Anda',
  isRequired = false,
  isPhoneUnRegistered = false,
  isPhoneRegistered = false,
  isEmailUnRegistered = false,
  isEmailRegistered = false,
  isPhoneVerified = false,
  isEmailVerified = false,
  isHarvester = false,
  isLandOwner = false,
  isRecentTrx = false,
  onSelectProject,
  isUppercaseValue,
  fieldName,
  invalid,
  onClickAdd,
  editValue,
  isVessel,
  onFetchingChange,
  innerRef,
  className,
  isCloseSelection = false,
  valueName,
  isCanClose = false,
  noAdd = false,
}) => {
  const dispatch = useDispatch()
  const { profile } = useSelector((s) => s.dashboard)

  const { isModalOpenAddProject } = useSelector((s) => s.project)
  const [isOpenSelection, setIsOpenSelection] = useState(false)
  const [localSearch, setLocalSearch] = useState('')
  const [project, setProject] = useState([])
  const [recentData, setRecentData] = useState([])
  const [isFetchingLocal, setIsFetchingLocal] = useState(false)
  const [lastActiveField, setLastActiveField] = useState(null)
  const [hasSelected, setHasSelected] = useState(false)

  const [fetchProject] = useLazyFindProjectQuery()

  const wrapperRef = useRef(null)

  const debouncedSearch = useDebounce((value) => {
    const trimmedValue = value.trim()
    if (trimmedValue) {
      setIsFetchingLocal(true)
      fetchProject({
        s: trimmedValue,
        ...(isPhoneUnRegistered && { isPhoneUnRegistered: true }),
        ...(isPhoneRegistered && { isPhoneRegistered: true }),
        ...(isEmailUnRegistered && { isEmailUnRegistered: true }),
        ...(isEmailRegistered && { isEmailRegistered: true }),
        ...(isPhoneVerified && { isPhoneVerified: true }),
        ...(isEmailVerified && { isEmailVerified: true }),
        ...(isHarvester && { isHarvester: true }),
        ...(isLandOwner && { isLandOwner: true }),
      }).then((response) => {
        setProject(response?.data?.items || [])
        setIsFetchingLocal(false)
        setIsOpenSelection(true)
      })
    } else {
      setIsOpenSelection(false)
      setProject([])
    }
  }, 600)

  const handleManualChange = (e) => {
    const value = e.target.value
    setLocalSearch(value)
    setHasSelected(false)

    if (onSelectProject) {
      onSelectProject(null, fieldName)
    }

    if (value.length > 2) {
      debouncedSearch(value)
    } else {
      setIsOpenSelection(false)
      setProject([])
      handleInitialFetch()
    }
  }

  const handleSelectContact = (contact) => {
    const relationName = isUppercaseValue
      ? contact?.label?.toUpperCase()
      : contact?.label

    const displayText = relationName || ''

    setLocalSearch(displayText)
    setIsOpenSelection(false)
    setHasSelected(true)
    if (onSelectProject) {
      onSelectProject(contact, fieldName)
    }
  }

  const handleInitialFetch = () => {
    setLastActiveField(fieldName)
    // if (!editValue) { // FOR AT THE MOMENT COMMENT THIS HANDLE
    setIsFetchingLocal(true)
    fetchProject({
      s: '',
      size: 10,
      page: 0,
      sortby: 'createdAt',
      sortdir: 'desc',
      ...(isPhoneUnRegistered && { isPhoneUnRegistered }),
      ...(isPhoneRegistered && { isPhoneRegistered }),
      ...(isEmailUnRegistered && { isEmailUnRegistered }),
      ...(isEmailRegistered && { isEmailRegistered }),
      ...(isPhoneVerified && { isPhoneVerified }),
      ...(isEmailVerified && { isEmailVerified }),
      ...(isHarvester && { isHarvester }),
      ...(isLandOwner && { isLandOwner }),
    }).then((response) => {
      setProject(response?.data?.items || [])
      setIsFetchingLocal(false)
      setIsOpenSelection(true)
    })
    // }
  }

  useEffect(() => {
    return () => {
      setLocalSearch('')
      setProject([])
      setLastActiveField(null)
    }
  }, [])

  useEffect(() => {
    if (!hasSelected && editValue) {
      setLocalSearch(editValue)
    }
  }, [editValue])

  useEffect(() => {
    if (!hasSelected && valueName) {
      setLocalSearch(valueName)
    }
  }, [valueName])

  useEffect(() => {
    if (onFetchingChange) {
      onFetchingChange(isFetchingLocal)
    }
  }, [isFetchingLocal, onFetchingChange])

  useEffect(() => {
    if (!isModalOpenAddProject && lastActiveField === fieldName) {
      handleInitialFetch()
    }
  }, [isModalOpenAddProject, fieldName, lastActiveField])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpenSelection(false)

        if (!hasSelected) {
          setLocalSearch('')
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [hasSelected])

  const toggleOpenCloseAddProject = () => {
    dispatch(setIsModalOpenAddProject(true))
  }

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }} className="w-100">
      <P size={isVessel ? 'regular' : 'default'} className="mb-2">
        {title}
        {isRequired && <span className="text-danger">*</span>}
      </P>

      <Input
        className={className}
        type="text"
        value={localSearch}
        onChange={handleManualChange}
        placeholder={placeholderDesc}
        onFocus={handleInitialFetch}
        // onBlur={() => setTimeout(() => setIsOpenSelection(false), 200)}
        // onBlur={() => {
        //   if (!hasSelected && !isCanClose) {
        //     return
        //   }

        //   setTimeout(() => setIsOpenSelection(false), 200)
        //   setLocalSearch('')
        // }}
        invalid={invalid}
        innerRef={innerRef}
      />
      {isOpenSelection && !isCloseSelection && (
        <div
          style={{
            position: 'absolute',
            background: 'white',
            width: '100%',
            boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            zIndex: 10,
            marginTop: '4px',
          }}
        >
          <div
            style={{
              maxHeight: '250px',
              overflowY: 'auto',
            }}
          >
            {isFetchingLocal ? (
              <div className="p-3 d-flex justify-content-center align-items-center">
                <Spinner size="sm" color="primary" />
              </div>
            ) : (
              <>
                <>
                  {project?.length > 0 ? (
                    project?.map((contact, index) => (
                      <div
                        key={index}
                        className="contact-item p-2 d-flex flex-column"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSelectContact(contact)}
                      >
                        <P color="#101828">{contact?.label ?? ''}</P>
                      </div>
                    ))
                  ) : (
                    <div className="p-2 text-muted">
                      Pencarian tidak ditemukan
                    </div>
                  )}
                </>
              </>
            )}
          </div>
          {!isFetchingLocal && !noAdd && (
            <div
              style={{
                padding: '8px',
                cursor: 'pointer',
                color: '#006386',
                background: 'white',
              }}
              onClick={() => {
                toggleOpenCloseAddProject()
                onClickAdd(localSearch)
              }}
            >
              + Tambah "{localSearch}" ke daftar project
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default InputProject
